<template>
  <div>
    <div>
      <b-card-actions
        title="Filters"
        action-collapse
        collapsed
      >
        <b-row>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Invoice No"
              label-for="v-invoice-no"
            >
              <b-form-input
                id="v-invoice-no"
                v-model="filters['invoice_no']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="!walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Merchant"
              label-for="merchant_name"
            >
              <v-select
                v-model="filters['merchant_id']"
                :options="merchantOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Merchant"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Walking Customer"
              label-for="senderName"
            >
              <v-select
                v-model="filters['merchant_id']"
                :options="walkingCustomers"
                :reduce="option => option.id"
                label="name"
                autocomplete="nope"
                placeholder="Select Walking Customer"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="!walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Status"
              label-for="invoice_status"
            >
              <v-select
                v-model="filters['status']"
                :options="statusOptions"
                :reduce="option => option.key"
                label="name"
                placeholder="Select Status"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="!walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Invoice Type"
              label-for="invoice_type"
            >
              <v-select
                v-model="filters['invoice_amount_after_taxes']"
                :options="invoiceTypeOptions"
                :reduce="option => option.key"
                label="name"
                placeholder="Select Type"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="!walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Invoice Date"
              label-for="Invoice-Date"
            >
              <div class="position-relative">
                <AdvancedDateFilter
                  :date-value="filters['created_at']"
                  :opens="'right'"
                  @update="updateDateRange('created_at', $event)"
                />
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1">
          <b-col>
            <filter-buttons
              :filter-data="filters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </b-card-actions>
    </div>
    <div
      v-if="!walkingCustomer"
    >
      <b-row class="match-height">
        <b-col
          sm="12"
          md="6"
          lg="4"
        >
          <overview-card
            title="All Invoices"
            :subtitle="allInvoice.total !== undefined && allInvoice.total !== null ? allInvoice.total + ' Invoices' : 'Loading...'"
            :sum="(allInvoice.count)"
            :border-variant="selectedCard == 'allInvoice' ? 'primary' : ''"
            tooltip-description="Displays the total sum of all invoices, both payable and receivable."
            icon="MenuIcon"
            indicator-color="#67b7b7 "
            @click.native="onCardSelect('allInvoice','');"
          />
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="4"
        >
          <overview-card
            title="Payable Invoice"
            :subtitle="payableInvoice.total !== undefined && payableInvoice.total !== null ? payableInvoice.total + ' Invoices' : 'Loading...'"
            :sum="(payableInvoice.count)"
            :border-variant="selectedCard == 'payableInvoice' ? 'primary' : ''"
            tooltip-description="Shows the total amount of invoices that are due for payment."
            icon="PlusSquareIcon"
            indicator-color="#6a76b0"
            @click.native="onCardSelect('payableInvoice','payable','invoice_amount_after_taxes');"
          />
        </b-col>
        <b-col
          sm="12"
          md="12"
          lg="4"
        >
          <overview-card
            title="Receivable Invoice"
            :subtitle="receivableInvoice.total !== undefined && receivableInvoice.total !== null ? receivableInvoice.total + ' Invoices' : 'Loading...'"
            :sum="(receivableInvoice.count)"
            :border-variant="selectedCard == 'receivableInvoice' ? 'primary' : ''"
            tooltip-description="Shows the total amount of invoices that are pending to be received."
            icon="MinusSquareIcon"
            indicator-color="#64c778"
            @click.native="onCardSelect('receivableInvoice','receivable','invoice_amount_after_taxes');"
          />
        </b-col>
      </b-row>
    </div>
    <div>
      <b-card
        no-body
      >
        <div
          class="m-2"
        >
          <b-row class="d-sm-flex align-items-start">
            <b-col
              md="12"
              lg="8"
              class="d-block d-sm-flex flex-wrap justify-content-start align-items-center mb-1 mb-md-0"
            >
              <b-button
                v-if="!walkingCustomer && depositSelected.length > 0 && hasFKey1Selected"
                v-can="'merchant-finance-paid'"
                :disabled="hasMixedStatus"
                class="mr-1 add-margin-bottom"
                variant="success"
                @click="onClickMakePayment()"
              >
                Make Payment
              </b-button>
              <b-button
                v-if="!walkingCustomer && canShowSubmittedApprove && depositSelected.length > 0 && hasFKey4Selected"
                v-can="'merchant-finance-approve'"
                :disabled="hasMixedStatus"
                class="mr-1 add-margin-bottom"
                variant="info"
                @click="onClickSubmittedApprove()"
              >
                Approve
              </b-button>
              <b-button
                v-if="!walkingCustomer && canShowSubmittedApprove && depositSelected.length > 0 && hasFKey4Selected"
                v-can="'merchant-finance-reject'"
                :disabled="hasMixedStatus"
                class="mr-1 add-margin-bottom"
                variant="danger"
                @click="onClickReject()"
              >
                Reject
              </b-button>
              <b-button
                v-if="!walkingCustomer"
                v-can="'merchant-finance-create'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                class="custom-button-color add-margin-bottom"
                @click="onClickNewInvoice()"
              >
                <feather-icon icon="PlusIcon" />
                Add New Invoice
              </b-button>
            </b-col>
            <b-col
              class="d-flex justify-content-end align-items-center mb-1 mb-md-0"
            >
              <ReportTableButtons
                :items="items"
                :json_fieldz="json_fields"
                :name="`${walkingCustomer ? 'CustomerInvoices' : 'MerchantInvoices'} - Page ${page}.xls`"
                :bulkname="walkingCustomer ? 'CustomerInvoices.xls' : 'MerchantInvoices.xls'"
                :fetch="fetchDataForMerchantNoPagination"
                :table-fields="tableFields"
                :table-data="tableData"
                :title="`${walkingCustomer ? 'Customer Invoices' : 'Merchant Invoices'} - ${meta.from} to ${meta.to} of ${meta.total} entries`"
                :file-name="`${walkingCustomer ? 'CustomerInvoices' : 'MerchantInvoices'}_All.pdf`"
                :use-advanced-pdf="true"
                @refresh="onClickRefresh"
              />
            </b-col>
          </b-row>
          <b-row v-if="!walkingCustomer && hasMixedStatus && depositSelected.length > 0">
            <div class="col-12">
              <small class="text-danger ml-1">
                <feather-icon
                  icon="AlertTriangleIcon"
                  size="14"
                  class="mr-1"
                />
                Wrong status selected - Please select Invoices with the same status
              </small>
            </div>
          </b-row>
          <b-row v-if="!walkingCustomer">
            <div
              class="font-weight-bolder text-muted ml-1 mt-1"
            >
              {{ `${depositSelected.length} record${depositSelected.length === 1 ? '':'s'}` }} selected
            </div>
          </b-row>
        </div>

        <!-- table -->
        <b-overlay
          id="overlay-background"
          blur="10px"
          opacity="0.30"
          rounded="sm"
          variant="light"
        >
          <b-table
            :per-page="perPage"
            :items="items"
            :fields="visibleFields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            hover
            responsive
            striped
            show-empty
            sticky-header="100vh"
            class="hide-vertical-scroll"
          >
            <template #empty>
              <TableDataFetching
                :rows="items"
                :data-loading="dataLoading"
              />
            </template>
            <template #head(id)>
              <div class="d-flex align-items-start">
                <div>
                  <b-form-checkbox
                    id="selectAllCheckbox"
                    v-model="selectAllCheckbox"
                    name="selectAllCheckbox"
                    @change="onClickSelectAllCheckbox()"
                  />
                </div>
              </div>
            </template>
            <template #cell(id)="data">
              <div class="d-flex align-items-start">
                <div>
                  <div class="font-weight-bolder">
                    <b-form-checkbox
                      v-model="depositSelected"
                      :value="data.item.id"
                    />
                  </div>
                </div>
              </div>
            </template>
            <template #cell(merchant.name)="data">
              <div class="d-flex align-items-start">
                <div>
                  <div class="">
                    {{ walkingCustomer ? data.item.walking_customer.name : `${data.value}${data.item.merchant.merchant_setting.merchant_type === 'cash' ? "&nbsp;[&nbsp;C&nbsp;]" : ''}` }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(merchant_business)="data">
              <span>{{ data.item.merchant_business || '---' }}</span>
            </template>
            <template #cell(invoice_no)="data">
              <div class="d-flex align-items-center">
                <b-avatar
                  :text="avatarText(data.item.invoice_no)"
                  size="32"
                  variant="light-primary"
                />
                <div class="ml-1">
                  <div
                    class="font-weight-bolder text-primary"
                    @click="onClickInvoice(data.item.id)"
                  >
                    {{ data.value }}
                  </div>
                  <div class="font-small-2">
                    {{ __dateTimeFormatter(data.item.created_at) }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(commission_rate)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(collected_cod)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(delivery_charge)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(commission_amount)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(total_tax_applied)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(invoice_amount)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(invoice_amount_after_taxes)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(deposited_date)="data">
              {{ __dateTimeFormatter(data.value) || '---' }}
            </template>
            <template #cell(approved_date)="data">
              {{ __dateTimeFormatter(data.value) || '---' }}
            </template>
            <template #cell(submitted_payment_approved_or_rejected_by)="data">
              <div
                v-if="isFKey4Active"
                class="d-flex align-items-center justify-content-center"
              >
                <div
                  v-if="data.value"
                  class="d-flex align-items-center"
                >
                  <b-avatar
                    v-if="data.value.avatar"
                    :src="`${bucketUrl}${data.value.avatar}`"
                    size="24"
                    class="mr-1"
                  />
                  <b-avatar
                    v-else
                    :text="avatarText(data.value.name || `${data.value.first_name} ${data.value.last_name}`.trim())"
                    size="24"
                    variant="light-primary"
                    class="mr-1"
                  />
                  <div>
                    <div class="font-small-2">{{ data.value.name || `${data.value.first_name} ${data.value.last_name}`.trim() || '---' }}
                    </div>
                    <div class="font-small-3 text-muted">{{ __dateTimeFormatter(data.item.submitted_payment_approved_rejected_at) || '---' }}
                    </div>
                  </div>
                </div>
                <span
                  v-else
                  class="text-muted"
                >---</span>
              </div>
              <span
                v-else
                class="text-muted"
              >---</span>
            </template>
            <template #cell(finance_current_status.key)="data">
              <finance-status-badge
                :status-key="data.value"
                :finance-status="statusOptions"
              />
              <div
                v-if="data.item.is_reversed_deposit"
                class="mt-1 d-flex justify-content-center"
              >
                <b-tooltip
                  :target="data.item.id.toString()"
                  triggers="hover"
                  variant="danger"
                >
                  Rejected Once
                </b-tooltip>
                <b-avatar
                  :id="data.item.id.toString()"
                  size="20"
                  style="background-color: #ffb5b5"
                >
                  <feather-icon
                    icon="ChevronsLeftIcon"
                    class="text-body align-middle"
                  />
                </b-avatar>
              </div>
            </template>
            <template #cell(action)="data">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                :class="items.length !== 1 ? 'dropdown-no-scroll':''"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="12"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  :to="{ name: walkingCustomer ? 'walking-finance-invoice' :'merchant-finance-invoice', params: { id: data.item.id } }"
                >
                  <feather-icon icon="BookIcon" />
                  View Invoice
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="data.item.receipt_url"
                  :href="`${bucketUrl}${data.item.receipt_url}`"
                  target="_blank"
                >
                  <feather-icon icon="EyeIcon" />
                  View Payment Slip
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="data.item.is_reversed_deposit"
                  @click="onClickShowRejectionReasons(data.item.id)"
                >
                  <feather-icon icon="BookIcon" />
                  Rejection Reasons
                </b-dropdown-item>
                <b-dropdown-item
                  v-can="'merchant-finance-show'"
                  :to="{ name: walkingCustomer ? 'walking-orders':'merchant-orders', params: { id: data.item.id } }"
                >
                  <feather-icon icon="ArchiveIcon" />
                  View Orders
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!walkingCustomer"
                  @click="onClickOpenRequestPaymentModal(data.item.id)"
                >
                  <feather-icon icon="PocketIcon" />
                  View Payment Requests
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-overlay>

        <div class="mx-2 mb-2">
          <b-row
            cols="12"
          >
            <b-col
              class="d-flex align-items-center justify-content-sm-start"
              md="3"
            >
              <label class="width-75">Per page</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="pageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block width-100"
              />
            </b-col>
            <!-- Pagination -->
            <b-col
              class="d-flex align-items-center justify-content-sm-end"
              md="9"
            >
              <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
              <b-pagination
                v-model="page"
                :total-rows="(meta.total)? meta.total : 0"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
      <request-payment ref="merchant_payment_request_modal" />
    </div>
    <make-deposite-action ref="make_deposit_action_modal" />
    <submitted-approve-action ref="submitted_approve_action_modal" />
    <reject-action ref="reject_action_modal" />
    <rejection-details ref="rejection_detail_modal" />
  </div>
</template>

<script>
import {
  BFormCheckbox,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  VBModal,
  BOverlay,
  BAvatar,
  VBTooltip,
  BTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { bucketUrl } from '@/constants/config'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import FinanceStatusBadge from '@core/components/status/FinanceStatusBadge.vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import store from '@/store/index'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import MakeDepositeAction from '@/components/FinanceModuleForms/ActionForms/MakeDepositeAction.vue'
import SubmittedApproveAction from '@/components/FinanceModuleForms/ActionForms/SubmittedApproveAction.vue'
import RejectAction from '@/components/FinanceModuleForms/ActionForms/RejectAction.vue'
import requestPayment from '@/components/RequestPayment/requestPayment.vue'
import RejectionDetails from '@/components/FinanceModuleForms/InfoModals/RejectionDetailModal.vue'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import OverviewCard from '@core/components/overview-card/OverviewCard.vue'

const FinanceRepository = RepositoryFactory.get('finance')
const MerchantRepository = RepositoryFactory.get('merchant')
const WalkingCustomerRepository = RepositoryFactory.get('walkingCustomer')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    MakeDepositeAction,
    SubmittedApproveAction,
    RejectAction,
    vSelect,
    AdvancedDateFilter,
    BTooltip,
    BOverlay,
    BCard,
    BTable,
    BAvatar,
    BFormCheckbox,
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BButton,
    BFormInput,
    BDropdown,
    BDropdownItem,
    requestPayment,
    FinanceStatusBadge,
    BCardActions,
    RejectionDetails,
    FilterButtons,
    OverviewCard,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage],
  data() {
    let walkingCustomer = false
    if (window.location.href.includes('walking')) walkingCustomer = true
    return {
      bucketUrl,
      depositSelected: [],
      merchantOptions: [],
      walkingCustomers: [],
      filters: {
        created_at: {
          startDate: null,
          endDate: null,
        },
      },
      dataLoading: false,
      sort: '',
      avatarText,
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      meta: {},
      dir: false,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [],
      json_fields: {
        'Invoice NO': 'invoice_no',
        'Deposit Date': {
          field: 'created_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        ...(walkingCustomer
          ? {
            Customer: {
              field: 'walking_customer.name',
              callback: value => `"${value}"`,
            },
          }
          : {
            'Merchant Reference Number': {
              field: 'merchant.ref_no',
              callback: value => `"${value}"`,
            },
            Merchant: {
              field: 'merchant.name',
              callback: value => `"${value}"`,
            },
            'Merchant Business': {
              field: 'merchant_business',
              callback: value => `"${value}"`,
            },
          }),
        'Commission Rate': 'commission_rate',
        'Collected COD': 'collected_cod',
        'Commission Amount': 'commission_amount',
        'Delivery Charge': 'delivery_charge',
        'Invoice Amount': 'invoice_amount',
        'Total Tax Amount': 'total_tax_applied',
        'After Tax Amount': 'invoice_amount_after_taxes',
        ...(!walkingCustomer
          ? {
            'Paid Date': {
              field: 'deposited_date',
              // eslint-disable-next-line no-underscore-dangle
              callback: value => this.__dateTimeFormatter(value),
            },
          }
          : {}),
        'Approved Date': {
          field: 'approved_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Submitted Payment Approved/Rejected By': {
          field: 'submitted_payment_approved_or_rejected_by',
          callback: value => (value ? (value.name || `${value.first_name} ${value.last_name}`.trim() || '---') : '---'),
        },
        Status: 'status.name',
      },
      items: [],
      statusOptions: [],
      invoiceTypeOptions: [
        {
          name: 'Payable',
          key: 'payable',
        },
        {
          name: 'Receivable',
          key: 'receivable',
        },
      ],
      walkingCustomer,
      selectAllCheckbox: false,
      allInvoice: { total: null, count: undefined },
      payableInvoice: { total: null, count: undefined },
      receivableInvoice: { total: null, count: undefined },
      selectedCard: 'allInvoice',
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.visibleFields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    canShowSubmittedApprove() {
      // Check if f_key_2 status is active
      const fKey2Status = this.statusOptions.find(status => status.key === 'f_key_2')
      return fKey2Status && fKey2Status.is_active
    },
    hasFKey1Selected() {
      // Check if any of the selected items have f_key_1 status
      return this.depositSelected.some(selectedId => {
        const selectedItem = this.items.find(item => item.id === selectedId)
        return selectedItem && selectedItem.finance_current_status && selectedItem.finance_current_status.key === 'f_key_1'
      })
    },
    hasFKey4Selected() {
      // Check if any of the selected items have f_key_4 status
      return this.depositSelected.some(selectedId => {
        const selectedItem = this.items.find(item => item.id === selectedId)
        return selectedItem && selectedItem.finance_current_status && selectedItem.finance_current_status.key === 'f_key_4'
      })
    },
    hasMixedStatus() {
      // Check if selected items have different statuses
      if (this.depositSelected.length <= 1) {
        return false // No mixed status if only one or no items selected
      }
      const selectedStatuses = this.depositSelected.map(selectedId => {
        const selectedItem = this.items.find(item => item.id === selectedId)
        return selectedItem && selectedItem.finance_current_status ? selectedItem.finance_current_status.key : null
      }).filter(status => status !== null)
      // Check if all selected items have the same status
      const uniqueStatuses = [...new Set(selectedStatuses)]
      return uniqueStatuses.length > 1
    },
    isFKey4Active() {
      // Check if f_key_4 status is active
      const fKey4Status = this.statusOptions.find(status => status.key === 'f_key_4')
      return fKey4Status && fKey4Status.is_active
    },
    visibleFields() {
      // Filter fields based on visibility
      return this.fields.filter(field => field.visible !== false)
    },
    tableFields() {
      return [
        'Invoice',
        'Invoice Date',
        'Merchant Ref No',
        this.walkingCustomer ? 'Walking Customer' : 'Merchant',
        this.walkingCustomer ? 'Customer' : 'Merchant Business',
        'Commission Rate',
        'Collected COD',
        'Commission Amount',
        'Delivery Charge',
        'Invoice Amount',
        'Total Tax Amount',
        'After Tax Amount',
        'Paid Date',
        'Approved Date',
        'Submitted Payment Approved/Rejected By',
        'Status',
      ]
    },
    tableData() {
      return this.items.map(item => [
        item.invoice_no,
        // eslint-disable-next-line no-underscore-dangle
        item.created_at ? this.__dateTimeFormatter(item.created_at) : '-',
        item.merchant ? item.merchant.ref_no : 'N/A',
        item.merchant ? item.merchant.name : 'N/A',
        item.merchant_business || 'N/A',
        item.commission_rate ? `${item.commission_rate}%` : '-',
        item.collected_cod ? item.collected_cod.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
        item.commission_amount ? item.commission_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
        item.delivery_charge ? item.delivery_charge.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
        item.invoice_amount ? item.invoice_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
        item.total_tax_applied ? item.total_tax_applied.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
        item.invoice_amount_after_taxes ? item.invoice_amount_after_taxes.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
        // eslint-disable-next-line no-underscore-dangle
        item.deposited_date ? this.__dateTimeFormatter(item.deposited_date) : '-',
        // eslint-disable-next-line no-underscore-dangle
        item.approved_date ? this.__dateTimeFormatter(item.approved_date) : '-',
        item.submitted_payment_approved_or_rejected_by ? item.submitted_payment_approved_or_rejected_by.name : 'N/A',
        item.finance_current_status ? item.finance_current_status.name : 'N/A',
      ])
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchDataForMerchant()
      },
    },
    deep: true,
    page() {
      this.fetchDataForMerchant()
    },
    perPage() {
      this.fetchDataForMerchant()
    },
    selectedCard() {
      this.fetchDataForMerchant()
    },
  },
  async mounted() {
    this.fields.push(
      {
        key: 'id',
        sortable: false,
      },
      {
        key: 'invoice_no',
        label: 'Invoice',
        sortable: true,
      },
      {
        key: 'merchant.ref_no',
        label: 'Merchant ref no',
        sortable: true,
      },
      {
        key: 'merchant.name',
        label: this.walkingCustomer ? 'Walking Customer' : 'Merchant',
        sortable: true,
      },
      {
        key: 'merchant_business',
        label: this.walkingCustomer ? 'Customer' : 'Merchant Business',
        sortable: true,
      },
      {
        key: 'commission_rate',
        label: 'Commission Rate',
        thClass: 'text-center',
        tdClass: 'text-center',
        sortable: true,
      },
      {
        key: 'collected_cod',
        label: `Collected COD(${this.currency_type})`,
        thClass: 'text-right',
        tdClass: 'text-right',
        sortable: true,
      },
      {
        key: 'commission_amount',
        label: `Commission Amount(${this.currency_type})`,
        thClass: 'text-right',
        tdClass: 'text-right',
        sortable: false,
      },
      {
        key: 'delivery_charge',
        label: `Delivery Charge(${this.currency_type})`,
        thClass: 'text-right',
        tdClass: 'text-right',
        sortable: true,
      },
      {
        key: 'invoice_amount',
        label: `Invoice Amount(${this.currency_type})`,
        thClass: 'text-right',
        tdClass: 'text-right',
        sortable: true,
      },
      {
        key: 'total_tax_applied',
        label: `Total Tax Amount(${this.currency_type})`,
        thClass: 'text-right',
        tdClass: 'text-right',
        sortable: true,
      },
      {
        key: 'invoice_amount_after_taxes',
        label: `After Tax Amount(${this.currency_type})`,
        thClass: 'text-right',
        tdClass: 'text-right',
        sortable: true,
      },
      // {
      //   key: 'invoice_amount',
      //   label: 'Invoice Amount',
      //   thClass: 'text-center',
      //   tdClass: 'text-center',
      //   sortable: true,
      // },
      {
        key: 'deposited_date',
        label: 'Paid Date',
        thClass: 'text-center',
        tdClass: 'text-center',
        sortable: true,
      },
      {
        key: 'approved_date',
        label: 'Approved Date',
        thClass: 'text-center',
        tdClass: 'text-center',
        sortable: true,
      },
      {
        key: 'submitted_payment_approved_or_rejected_by',
        label: 'Submitted Payment Approved/Rejected By',
        thClass: 'text-center',
        tdClass: 'text-center',
        sortable: true,
        visible: false,
      },
      {
        key: 'finance_current_status.key',
        label: 'Status',
        thClass: 'text-center',
        tdClass: 'text-center',
        sortable: true,
      },
      {
        key: 'action',
        label: 'Action',
        sortable: false,
      },
    )
    // Set the initial number of items
    this.totalRows = this.items.length
    if (this.walkingCustomer) {
      this.fields = this.fields.filter(f => f.key !== 'id' && f.key !== 'collected_cod' && f.key !== 'invoice_amount' && f.key !== 'commission_rate' && f.key !== 'commission_amount' && f.key !== 'deposited_date' && f.key !== 'merchant.ref_no' && f.key !== 'merchant_business')
      await this.$set(this.filters, 'orderable_type', 'walking')
      this.getWalkingCustomerList()
    } else {
      await this.$set(this.filters, 'orderable_type', 'merchant')
      this.getMerchantList()
    }
    await this.getFinanceStatusList()
    this.getMerchantList()
    this.fetchDataForMerchant()
    this.readInvoiceTypeData()
    this.updateFieldsVisibility()
  },
  methods: {
    async getFinanceStatusList() {
      try {
        // Check if status data exists in localStorage first
        const cachedStatuses = localStorage.getItem('finance_statuses')
        if (cachedStatuses) {
          this.statusOptions = JSON.parse(cachedStatuses)
        } else {
          // Fetch from API if not cached
          const { data } = await FinanceRepository.getFinanceStatusList()
          this.statusOptions = data.data || data
          // Cache the data for future use
          localStorage.setItem('finance_statuses', JSON.stringify(this.statusOptions))
        }
      } catch (error) {
        this.statusOptions = []
      }
    },
    updateFieldsVisibility() {
      // Update visibility of f_key_4 related columns based on status
      const fKey4Status = this.statusOptions.find(status => status.key === 'f_key_4')
      const isFKey4Active = fKey4Status && fKey4Status.is_active

      this.fields.forEach((field, index) => {
        if (field.key === 'submitted_payment_approved_or_rejected_by') {
          this.$set(this.fields, index, { ...field, visible: isFKey4Active })
        }
      })
    },
    async getMerchantList() {
      this.merchantOptions = localStorage.getItem('merchant_list') ? JSON.parse(localStorage.getItem('merchant_list')) : (await MerchantRepository.getMerchantListForDropdown()).data.data
      if (!localStorage.getItem('merchant_list')) localStorage.setItem('merchant_list', JSON.stringify(this.merchantOptions))
    },
    async getWalkingCustomerList() {
      this.walkingCustomers = localStorage.getItem('walking_customer_list') ? JSON.parse(localStorage.getItem('walking_customer_list')) : (await WalkingCustomerRepository.getWalkingCustomerDropdownList()).data.data
      if (!localStorage.getItem('walking_customer_list')) localStorage.setItem('walking_customer_list', JSON.stringify(this.walkingCustomers))
    },
    async fetchDataForMerchant() {
      this.dataLoading = true
      this.items = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await FinanceRepository.getMerchantFinanceDepositList(this.page, filterQuery, this.perPage, this.sort))
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchDataForMerchantNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await FinanceRepository.getMerchantFinanceDepositListNoPagination(filterQuery))
        // Transform the data to match tableData format
        return data.data.map(item => [
          item.invoice_no,
          // eslint-disable-next-line no-underscore-dangle
          item.created_at ? this.__dateTimeFormatter(item.created_at) : '-',
          item.merchant ? item.merchant.ref_no : 'N/A',
          item.merchant ? item.merchant.name : 'N/A',
          item.merchant_business || 'N/A',
          item.commission_rate ? `${item.commission_rate}%` : '-',
          item.collected_cod ? item.collected_cod.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          item.commission_amount ? item.commission_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          item.delivery_charge ? item.delivery_charge.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          item.invoice_amount ? item.invoice_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          item.total_tax_applied ? item.total_tax_applied.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          item.invoice_amount_after_taxes ? item.invoice_amount_after_taxes.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-',
          // eslint-disable-next-line no-underscore-dangle
          item.deposited_date ? this.__dateTimeFormatter(item.deposited_date) : '-',
          // eslint-disable-next-line no-underscore-dangle
          item.approved_date ? this.__dateTimeFormatter(item.approved_date) : '-',
          item.finance_current_status ? item.finance_current_status.name : 'N/A',
        ])
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    handleChangePage(page) {
      this.page = page
      this.fetchDataForMerchant()
    },
    applyFilters() {
      this.fetchDataForMerchant()
      this.deselectAll()
      this.readInvoiceTypeData()
    },
    clearFilters() {
      this.filters = {
        created_at: {
          startDate: null,
          endDate: null,
        },
      }
      this.$nextTick(() => {
        if (this.walkingCustomer) {
          this.$set(this.filters, 'orderable_type', 'walking')
        } else {
          this.$set(this.filters, 'orderable_type', 'merchant')
        }
        this.$nextTick(() => {
          this.fetchDataForMerchant()
          this.readInvoiceTypeData()
        })
      })
    },
    onClickOpenRequestPaymentModal(id) {
      this.$refs.merchant_payment_request_modal.openModal(id)
    },
    onClickShowRejectionReasons(id) {
      this.$refs.rejection_detail_modal.openModal(id, 'merchant')
    },
    selectAll() {
      this.depositSelected = this.items.map(n => n.id)
    },
    deselectAll() {
      this.depositSelected = []
    },
    onClickMakePayment() {
      this.$refs.make_deposit_action_modal.openModal(this.depositSelected, 'merchant')
    },
    onClickSubmittedApprove() {
      this.$refs.submitted_approve_action_modal.openModal(this.depositSelected, 'merchant')
    },
    onClickReject() {
      this.$refs.reject_action_modal.openModal(this.depositSelected, 'merchant')
    },
    onClickNewInvoice() {
      this.$router.push({ name: 'add-new-merchant-invoice' })
    },
    onClickRefresh() {
      this.fetchDataForMerchant()
      this.deselectAll()
      this.readInvoiceTypeData()
    },
    onClickInvoice(invoice) {
      if (this.walkingCustomer) {
        this.$router.push({
          name: 'walking-finance-invoice',
          params: {
            id: invoice,
          },
        })
      } else {
        this.$router.push({
          name: 'merchant-finance-invoice',
          params: {
            id: invoice,
          },
        })
      }
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.depositSelected = this.items.map(n => n.id)
      } else {
        this.depositSelected = []
      }
    },
    async readInvoiceTypeData() {
      try {
        this.getAllInvoicesSummary()
        this.getPayableInvoicesSummary()
        this.getReceivableInvoicesSummary()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async getAllInvoicesSummary() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await FinanceRepository.getAllInvoicesSummary(this.filterQuery))
        this.allInvoice.total = data.all_invoice.total
        const allInvoiceCount = Math.abs(data.all_invoice.sum ?? 0)
        this.allInvoice.count = allInvoiceCount
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getPayableInvoicesSummary() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await FinanceRepository.getPayableInvoicesSummary(this.filterQuery))
        this.payableInvoice.total = data.payable_invoice.total
        this.payableInvoice.count = data.payable_invoice.sum
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getReceivableInvoicesSummary() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await FinanceRepository.getReceivableInvoicesSummary(this.filterQuery))
        this.receivableInvoice.total = data.receivable_invoice.total
        const receivableInvoiceCount = Math.abs(data.receivable_invoice.sum ?? 0)
        this.receivableInvoice.count = receivableInvoiceCount
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onCardSelect(selectedCard, key, attribute) {
      this.selectedCard = selectedCard
      this.selectedKey = key
      this.attribute = attribute

      if (key && attribute) {
        this.filters = {
          ...this.filters,
          [`${attribute}`]: key, // Dynamically create filter like filter[invoice_amount_after_taxes]: payable
          [`${'orderable_type'}`]: 'merchant',
        }
      } else {
        this.filters = {
          ...this.filters,
          [`${'orderable_type'}`]: 'merchant',
        }
      }
    },
  },
}
</script>
<style lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';
@media (max-width: 767px) {
  .add-margin-bottom {
    width: 100%;
    margin-bottom: 20px;
  }
  .pagination-text {
    font-size: 0.75rem;
  }
}
</style>
